import './style.scss';

const Button = (props) => {
  const { label, action, toUpperCase, disabled } = props;
  return (
    <button
      className='tes-button'
      onClick={(e) => {
        e.preventDefault();
        if (typeof action === 'function') {
          action();
        }
      }}
      disabled={disabled}
    >
      {toUpperCase === false ? label : label.toUpperCase()}
    </button>
  );
};

export default Button;
